import { render, staticRenderFns } from "./add_work_equipment.vue?vue&type=template&id=2352f222&lang=pug&"
import script from "./add_work_equipment.vue?vue&type=script&lang=js&"
export * from "./add_work_equipment.vue?vue&type=script&lang=js&"
import style0 from "./add_work_equipment.vue?vue&type=style&index=0&id=2352f222&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports